import {
  apiClient,
} from "./apiClient";

import type {
  UserAccountApplicationData,
} from "../types/accounts.types";

export const accountsApi = {
getUserApplication(
  uid: string,
) {
  return apiClient.get<
    UserAccountApplicationData
  >(
    `/users/${encodeURIComponent(
      uid,
    )}/account-request`,
  );
},
};